module.exports={
    zh:{
        code:"编号",
        Chinesename: '中文姓名',
        Englishname: '英文姓名',
        Childname: '宝宝姓名',
        birthday:"生日",
        studentType:"学生类型",
        AffiliatedGarden: '所属园区',
        class:"班级",
        schoolState:"在校状态",
        search: '搜索',
        reset: '重置',
        add: '添加',
        leaveSchool:'离园',
        goUp:"升班",
        export: '导出',
        Import: '导入',
        importingStudents:'导入学生',
        downloadTemplate:'下载模版',
        number:'序号',
        operation:"操作",
        check:'查看',
        delete:"删除",
        allergen:"过敏源",
        foodTaboo:'食物禁忌',
        Registrationinfo:'登记信息',
        admission:'录取日期',
        enter:'入园日期',
        leave:'离园日期',
        approver :"批准人" ,
        leaveReason: '离校原因',
        remark:"备注",
        submit:"提交",
        sendTime: "发送时间",
        sender: "发送人",
        content: "内容",
        studentManageDetails: '学生管理详情',
        sunshineReport: {
            dateTime: '日期时间',
            sender: '发送人',
            contentsSummary: '内容摘要',
            action: '操作'
        }
    },
    en:{
        code:"code",
        Chinesename: 'Chinese name',
        Englishname: 'English name',
        Childname: 'Chils name',
        AffiliatedGarden: 'Affiliated Garden',
        class:"class",
        birthday:"birthday",
        studentType:"student Type",
        schoolState:"school Status",
        search: 'search',
        reset: 'reset',
        add: 'add',
        leaveSchool:'leave School',
        goUp:"go up",
        export: 'export',
        Import: 'Import',
        importingStudents:'Importing students',
        downloadTemplate:'Download template',
        number:'Number',
        operation:'operation',
        check:'check',
        delete:"delete",
        allergen:'Allergen',
        foodTaboo:'Food Taboo',
        Registrationinfo:'Registration information',
        admission:'Date of admission',
        enter:'Date of enter',
        leave:'Date of leave' ,
        approver :'Approver',
        leaveReason: 'Reasons for leaving school',
        remark:'remark',
        submit:"submit",
        sendTime: "send time",
        sender: "sender",
        content: "content",
        studentManageDetails: 'Student management details',
        sunshineReport: {
            dateTime: 'date time',
            sender: 'sender',
            contentsSummary: 'contents summary',
            action: 'action'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/i18n/lang/studentManage.js